import React from 'react';
import { Flex } from 'antd';
import { spacing } from '../../theming';

const LanguageOption = ({ flag, label }) => (
    <Flex align="center" gap={spacing[1]}>
        <span>{flag}</span>
        <span>{label}</span>
    </Flex>
);

export default LanguageOption;
